import { useCaptureUtmParams } from "@store/hooks/useCaptureUtm";

// Component wrapper for all routes when all providers are loaded
export default function RootComponentWrapper({ children }) {
    useCaptureUtmParams();

    return <>{children}</>;
}
